import client from '~/utils/client';
import { productFragment } from '~/utils/queries';

export const fetchProductBySlug = async (slug: string) => {
  return await client.request(
    `
    query($slug: String!) {
      product(slug: $slug) {
        ${productFragment}
        collections {
          id
        }
        relatedProducts {
          ${productFragment}
        }
      }
    }
  `,
    {
      slug,
    },
    {
      cache: true,
    },
  );
};

export const fetchProductById = async (id: string) => {
  return await client.request(
    `
    query($id: ID!) {
      product(id: $id) {
        ${productFragment}
        collections {
          id
        }
        relatedProducts {
          ${productFragment}
        }
      }
    }
  `,
    {
      id,
    },
    {
      cache: true,
    },
  );
};

export const fetchProductIncludeUnpublished = async (id: string) => {
  return await client.request(
    `
    query($id: ID!) {
      product: productIncludeUnpublished(id: $id) {
        ${productFragment}
        collections {
          id
        }
        relatedProducts {
          ${productFragment}
        }
      }
    }
  `,
    {
      id,
    },
    {
      cache: true,
    },
  );
};
